
import.meta.glob('../components/**/*_component.vue', {eager: true})
import "./../application"
import './agent'
// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import {createWebHistory, createRouter} from 'vue-router'
import {createApp} from 'vue/dist/vue.esm-bundler';


import RoiCalculator from '~/components/roi-calculator/index.vue';

import NewTemplate from '~/components/dashboard/templates/new.vue';
import Dashboard from '~/components/dashboard/index.vue';
import Site from '~/components/dashboard/sites/show.vue';
import Machine from '~/components/dashboard/machines/show.vue';
import MachineSensors from '~/components/dashboard/machines/sensors/index.vue';
import AiInspection from '~/components/dashboard/inspections/ai_inspection.vue';
import Conversations from '~/components/dashboard/conversations/index.vue';
import CustomerShow from '~/components/dashboard/customers/show.vue';
import WorkOrderShow from '~/components/dashboard/work_order/show.vue';

// import Devices from '~/components/dashboard/devices/index.vue';
import Devices from '~/components/dashboard/devices/index.vue';

let getRouter = function () {
    return createRouter({
        history: createWebHistory(``),
        routes:
            [
                {
                    path: '/dashboard/organizations/:organization_uuid/templates/:id/content',
                    component: NewTemplate,
                    name: 'edit_template_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/work_orders/:work_order_id',
                    component: WorkOrderShow,
                    name: 'work_order_path'
                },
                {
                    path: '/resources/roi-calculator',
                    component: RoiCalculator,
                    name: 'roi_calculator_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/ai-inspections/:ai_inspection_id/',
                    component: AiInspection,
                    name: 'show_dashboard_ai_inspection_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/',
                    component: Dashboard,
                    name: 'dashboard_path',
                    // alias: ['/', '']
                },
                {
                    path: '/dashboard/sites/:uuid',
                    component: Site,
                    name: 'show_dashboard_site_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/machines/:machine_id',
                    component: Machine,
                    name: 'show_dashboard_machine_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/fleet/:machine_id',
                    component: Machine,
                    name: 'show_dashboard_fleet_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/devices',
                    component: Devices,
                    name: 'show_dashboard_devices_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/fleet/:machine_id/machine_sensors',
                    component: MachineSensors,
                    name: 'machine_sensors_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/conversations/',
                    component: Conversations,
                    name: 'conversations_path'
                },
                {
                    path: '/dashboard/organizations/:organization_uuid/customers/:id/',
                    component: CustomerShow,
                    name: 'customer_path'
                },

            ]
    });
};
const appFactory = () => {
    let app = createApp("");
    let router = getRouter();
    app.use(router);
    app.mount('#app')
    // Handles 404 Not found
    router.beforeEach((to, from, next) => {
        /*  if (!to.matched.length) {
              window.location.href = '/404'
          } else {*/
        next();
        //  }
    });
}

document.addEventListener('turbo:load', () => {
    console.log('turbo:load');
    // app.unmount();
    appFactory();
    //console.log(app);
})